import { environment } from "environments/environment";

export const API_ENDPOINT = {
  REPORT_TEMPLATES: `${environment.apiBaseUrl}/TenantReportTemplates`,
  PHOTO: `${environment.apiBaseUrl}/photos`,
  GET_PREVIEW: `${environment.reportServerUrl}/createPreview`,
};
